import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Resources from "@/pages/Resources";

export const Route = createFileRoute("/es/recursos/")({
  head: () => buildRouteHead("/es/recursos"),
  component: Resources,
});
